import { getNamespacedLogger } from '../components/Logger';
import { NAMESPACE } from './app.constants';

const logger = getNamespacedLogger(NAMESPACE);

export default logger;
